import React from "react";
import SelectOption from "../../../../Table/Order/TestMaterialInfoTableForm/components/SelectOption";
import SelectOptionOther from "../../../../Table/Order/TestMaterialInfoTableForm/components/SelectOptionOther";

const dilutionMediaOptions = [
  {
    value: "依頼者",
    label: "依頼者",
  },
];

function SelectBillingAddress(props) {
  const { selectedValue, onSelect, isReadonly } = props;

  return (
    <div className="w-full h-full border border-solid border-[#B3B3B3] bg-white rounded-[10px]">
      <div
        className="w-full h-full py-2 px-2">
        <div className=" grid grid-cols-1 sm:grid-cols-4 items-center justify-center gap-2.5">
          <SelectOption
            label={dilutionMediaOptions[0].label}
            value={dilutionMediaOptions[0].value}
            onSelect={onSelect}
            isSelected={selectedValue === dilutionMediaOptions[0].value}
            isReadonly={isReadonly}
          />
          <SelectOptionOther
            selectedValue={selectedValue}
            onSelect={onSelect}
            isReadonly={isReadonly}
            otherPrefix="その他"
          />
        </div>
        <div className="flex-1 py-2 text-xs text-[#707070]">その他の場合は、会社名をご記入ください</div>
      </div>
    </div>
  );
}

export default SelectBillingAddress;
